import React from "react";
import { Box, Heading, Text, Button, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const options = ["Bat", "Ball"];

export const BatFlipPage: React.FC = () => {
  const [flipping, setFlipping] = React.useState(false);
  const [result, setResult] = React.useState<string | null>(null);
  const navigate = useNavigate();

  const flipBat = () => {
    setFlipping(true);
    setResult(null);
    setTimeout(() => {
      const res = options[Math.floor(Math.random() * options.length)];
      setResult(res);
      setFlipping(false);
    }, 1500);
  };

  return (
    <VStack
      minH="100vh"
      justify="center"
      align="center"
      bgGradient="linear(to-b, #e0eafc, #cfdef3)"
    >
      <Box position="absolute" top={4} left={4}>
        <Button onClick={() => navigate(-1)} variant="ghost" colorScheme="teal">
          Back
        </Button>
      </Box>
      <Heading size="2xl" color="#01579b" mb={2}>
        Bat Flip
      </Heading>
      <Text fontSize="lg" color="#333" mb={6} textAlign="center">
        Flip the bat to see if it lands on Bat or Ball!
      </Text>
      <Box
        w={72}
        h={32}
        display="flex"
        alignItems="center"
        justifyContent="center"
        mb={6}
        position="relative"
        style={{
          transform: flipping
            ? `rotateY                                                    (1440deg)`
            : result === "Ball"
            ? "rotateY(180deg)"
            : "rotateY(0deg)",
          transition: "transform 1.5s cubic-bezier(.17,.67,.83,.67)",
        }}
      >
        {/* SVG Cricket Bat (horizontal) */}
        <svg
          width="260"
          height="80"
          viewBox="0 0 260 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ zIndex: 1 }}
        >
          {/* Handle */}
          <rect
            x="20"
            y="32"
            width="60"
            height="16"
            rx="8"
            fill="#744210"
            stroke="#4a2c06"
            strokeWidth="2"
          />
          <rect
            x="20"
            y="32"
            width="20"
            height="16"
            rx="8"
            fill="#a67c52"
            stroke="#4a2c06"
            strokeWidth="1"
          />
          {/* Blade */}
          <rect
            x="80"
            y="20"
            width="140"
            height="40"
            rx="16"
            fill="#ffe0b2"
            stroke="#b7791f"
            strokeWidth="4"
          />
        </svg>
        {/* Centered text on bat blade */}
        <Box
          position="absolute"
          left="55%"
          top="50%"
          transform="translate(-50%, -50%)"
          zIndex={2}
          pointerEvents="none"
          minW={20}
          px={2}
          py={1}
        >
          <Text
            fontSize="2xl"
            color="#744210"
            fontWeight="bold"
            textAlign="center"
            userSelect="none"
          >
            {flipping ? "" : result || "Bat"}
          </Text>
        </Box>
      </Box>
      <Button
        colorScheme="orange"
        size="lg"
        onClick={flipBat}
        loading={flipping}
      >
        Flip Bat
      </Button>
      {result && (
        <Text fontSize="2xl" color="orange.600" mt={4} fontWeight="bold">
          Result: {result}
        </Text>
      )}
    </VStack>
  );
};

export default BatFlipPage;
